const PhoneNumber = "(13) 3822-7184";
const EmailAdress = "contato@alfadiagnostica.com.br";

export { PhoneNumber, EmailAdress };